module.exports = __webpack_public_path__ + "img/middle.19c90865.png";